import { Inspection } from '@sw-sw/lib-inspection-templates';
import xhrService from '../xhrService';
import { Finding } from './finding';
import db from '../../db/db';
const baseUrl = '/api/projects';

export type ProjectInspection = Omit<Inspection, 'id'> & {
  id: number;
  findings: Array<Finding>;
  pageNumber?: string | number | null;
  pageSize?: number,
  project?: any
  findingDetails?: any;
};

export type SlimProjectInspection = {
  id: number;
  created_date?: Date;
  certification_date?: Date;
  compliance_date?: Date;
  inspection_template?: {
    name?: string;
    inspectionTemplateType?: { id: number };
  };
};

export const projectInspectionApi = {
  index: async (
    id: number,
    pageNumber?: string | number | null,
    pageSize?: number,
    inspection_template_type_id?: number,
    inspectionType?: string,
    inspection_template_type?: string,
    inspection_type?: string
  ): Promise<any> => {
    const params: {
      p?: string | number | null;
      pageSize?: number;
      inspection_template_type_id?: number;
      inspectionType?: string;
      inspection_template_type?: string;
      inspection_type?: string;
    } = {};

    if (pageNumber) {
      params.p = pageNumber;
    }

    if (pageSize) {
      params.pageSize = pageSize;
    }

    if (inspection_template_type_id) {
      params.inspection_template_type_id = inspection_template_type_id;
    }

    if (inspectionType) {
      params.inspectionType = inspectionType;
    }

    if (inspection_template_type) {
      params.inspection_template_type = inspection_template_type;
    }

    if (inspection_type) {
      params.inspection_type = inspection_type;
    }

    const offline = navigator.onLine ? false : true;

    if (!offline) {
      return xhrService
        .get(`${baseUrl}/${id}/inspections`, { params })
        .then((response) => response.data);
    }
    else {
      const data = await db.inspections.where('project_id').equals(Number(id)).sortBy('inspectionNumber')
        .then((inspections: any) => inspections.reverse())
        .catch((e: any) => {
          console.log("error", e)
          throw e
        });

      return { pageData: data, paginationState: { currentPage: 1, pageSize: 1, numModels: 1 } }
    }
  },
  indexSlim: async (
    id: number,
    inspection_template_type_id?: number,
  ): Promise<any> => {
    const params: {
      slim: number;
      inspection_template_type_id?: number;
    } = { slim: 1 };

    if (inspection_template_type_id) {
      params.inspection_template_type_id = inspection_template_type_id;
    }

    const offline = navigator.onLine ? false : true;

    if (!offline) {
      return xhrService
        .get(`${baseUrl}/${id}/inspections`, { params })
        .then((response) => response.data);
    }
    else {
      const data = await db.inspections.where('project_id').equals(Number(id)).sortBy('inspectionNumber')
        .then((inspections: any) => inspections.reverse())
        .catch((e: any) => {
          console.log("error", e)
          throw e
        });

      return { pageData: data, paginationState: { currentPage: 1, pageSize: 1, numModels: 1 } }
    }
  },
  indexIds: (id: number, inspection_template_type_id?: number): any => {
    const params: { inspection_template_type_id?: number } = {};

    if (inspection_template_type_id) {
      params.inspection_template_type_id = inspection_template_type_id;
    }

    return xhrService
      .get(`${baseUrl}/${id}/inspections/Ids`, { params })
      .then((response) => response.data);
  },
  getInspectionTypesByProject: (projectId: number): Promise<string[]> =>
    xhrService
      .get(`${baseUrl}/${projectId}/inspections/inspection-types`)
      .then((response) => response.data.data),

};


export default projectInspectionApi;
